module.exports = __webpack_public_path__ + "img/Photos_Empanadas_menu_web-w.ce6cfe7b.jpg";